import { useContext } from 'react'
import { FormContext } from '@/components/changeRequests/formContext'
import { getDataPath } from '@/store/Forms'
import { getPath, toJs } from '@/components/changeRequests/propertyRenderer'
import { useSelector } from 'react-redux'

export function usePropertyReader (names, source = 'modifiedData') {
  const { uid } = useContext(FormContext)

  const forms = useSelector(state => state.forms)
  return names.map((name) => {
    const namePath = getPath(name)
    const valuePath = getDataPath(forms, uid, namePath, source)
    return toJs(forms.getIn(valuePath))
  })
}



// WEBPACK FOOTER //
// ./src/hooks/usePropertyReader.js